import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=10cf440c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cf440c')) {
      api.createRecord('10cf440c', component.options)
    } else {
      api.reload('10cf440c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=10cf440c&", function () {
      api.rerender('10cf440c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8WsyQkOL06k6v/JS/offershelp.vue"
export default component.exports